// extracted by mini-css-extract-plugin
export default {"checkBox":"Checkbox_checkBox__rVWI+","checked":"Checkbox_checked__rs3Ix"};